module.exports = {"350421100":"雪峰镇","350421101":"盖洋镇","350421102":"胡坊镇","350421103":"瀚仙镇","350421200":"城关乡","350421201":"沙溪乡","350421202":"夏阳乡","350421203":"枫溪乡","350421204":"夏坊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350421.json
// module id = 1188
// module chunks = 0